import styled from 'styled-components'

export const StyledLoginForm = styled.form`
  position: relative;
  width: 100%;
  max-width: var(--wd-card);
`
